import { Owner } from './owner'

export class PlayerOwner extends Owner {
  constructor(name, ranchName, homeRegion) {
    super(name, ranchName, homeRegion)
    this.isPlayer = true
    this.money = 10000
    this.reputation = 50
    this.inventory = []
  }

  addToInventory(item) {
    if (!this.inventory) {
      this.inventory = []
    }
    this.inventory.push({
      ...item,
      id: crypto.randomUUID(),
      dateAwarded: new Date().toISOString()
    })
  }

  toJSON() {
    return {
      ...super.toJSON(),
      isPlayer: this.isPlayer,
      money: this.money,
      reputation: this.reputation,
      inventory: this.inventory || []
    }
  }
}
